export const USTAW_DATE_MENU = 'USTAW_DATE_MENU';

export function ustawDateMenu(dataMenu) {
  return {
    type: USTAW_DATE_MENU,
    dataMenu,
  };
}
